// eslint-disable-next-line max-classes-per-file
import cloneDeep from 'lodash.clonedeep';

const YAxisConfigPropertyKey = {
  SeriesName: 'seriesName',
  Title: 'title',
  AxisTicks: 'axisTicks',
  AxisBorder: 'axisBorder',
  Labels: 'labels',
  ForceNiceScale: 'forceNiceScale',
  Opposite: 'opposite',
  Max: 'max',
  Min: 'min',
};

const DEFAULT_Y_AXIS_CONFIG = {
  [YAxisConfigPropertyKey.SeriesName]: '',
  [YAxisConfigPropertyKey.Title]: {
    text: '',
    style: {
      color: '#009fd4',
    },
  },
  [YAxisConfigPropertyKey.AxisTicks]: {
    show: true,
  },
  [YAxisConfigPropertyKey.AxisBorder]: {
    show: true,
    color: '#009fd4',
  },
  [YAxisConfigPropertyKey.Labels]: {
    formatter: (value) => value,
  },
};

class YAxisItemConfigBuilder {
  #config = cloneDeep(DEFAULT_Y_AXIS_CONFIG);

  setColor(color) {
    this.#config[YAxisConfigPropertyKey.Title].style.color = color;
    this.#config[YAxisConfigPropertyKey.AxisBorder].color = color;

    return this;
  }

  setTitle(title) {
    this.#config[YAxisConfigPropertyKey.Title].text = title;

    return this.#setProperty([YAxisConfigPropertyKey.SeriesName], title);
  }

  setLabelFormatter(formatter) {
    this.#config[YAxisConfigPropertyKey.Labels].formatter = formatter;

    return this;
  }

  setForceNiceScale(value) {
    return this.#setProperty(YAxisConfigPropertyKey.ForceNiceScale, value);
  }

  setOpposite(value) {
    return this.#setProperty(YAxisConfigPropertyKey.Opposite, value);
  }

  setMin(value) {
    return this.#setProperty(YAxisConfigPropertyKey.Min, value);
  }

  setMax(value) {
    return this.#setProperty(YAxisConfigPropertyKey.Max, value);
  }

  build() {
    return this.#config;
  }

  #setProperty(propertyName, value) {
    this.#config[propertyName] = value;

    return this;
  }
}

export default class YAxisConfigBuilder {
  #config = [];

  addYAxisItem(callback) {
    const yAxisItemConfigBuilder = new YAxisItemConfigBuilder();

    this.#config.push(yAxisItemConfigBuilder);
    callback(yAxisItemConfigBuilder);

    return this;
  }

  build() {
    return this.#config.map((item) => item.build());
  }
}
